import React, { Component } from 'react';
import cx from 'classnames';
import './VerticalProgress.css';
import { toNumber } from '../../../utils/numbers';

class VerticalProgress extends Component {
  render() {
    const { value, active, showPercent, showProgress, tolerance } = this.props;
    const toleranceUnderInPercent = toNumber(tolerance?.under || 0);
    const toleranceOverInPercent = toNumber(tolerance?.over || 0);
    const numericValue = toNumber(value);
    const percent = Number.isFinite(numericValue)
      ? Math.max(numericValue, 0)
      : 0;
    const height = percent;
    const completed = percent >= 100 - toleranceUnderInPercent && percent <= 100 + toleranceOverInPercent;
    const under = percent > 80 && percent < 100 - toleranceUnderInPercent;
    const over = percent > 100 + toleranceOverInPercent;

    const CN = cx('progress-bar progress-bar-striped', {
      active,
    });

    return (
      <div className="device-gui__progress">
        {!!showPercent && (
          <div className={cx('progress-value', { completed, under, over })}>{percent}%</div>
        )}
        {!!showProgress && (
          <div className="progress">
            <div className={CN} style={{ height: `${height}%` }} />
          </div>
        )}
      </div>
    );
  }
}

export default VerticalProgress;
